export const formatPercent = (
  numerator: number,
  denominator: number
): string => {
  const percent = Math.round((numerator / denominator) * 100);
  return `${String(percent)}%`;
};
